export { default } from "./InputPhone"
